import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { PieChartComponent } from './chart-types/pie-chart/pie-chart.component';
import { BarChartComponent } from './chart-types/bar-chart/bar-chart.component';
import { LineChartComponent } from './chart-types/line-chart/line-chart.component';

@NgModule({
  declarations: [
    PieChartComponent
  ],
  imports: [
    CommonModule,
    BaseChartDirective,
    BarChartComponent,
    LineChartComponent,
  ],
  exports: [
    PieChartComponent,
    BarChartComponent,
    LineChartComponent,
  ],
  providers: [
    provideCharts(withDefaultRegisterables())
  ]
})
export class DataChartModule { }
